import api from "./api";
// @ts-expect-error - api is not typed
const patients = api.getPrefixedMethods("patients");
// @ts-expect-error - api is not typed
const intake = api.getPrefixedMethods("intake");
// @ts-expect-error - api is not typed
const settings = api.getPrefixedMethods("settings");
/** Statuses a run passes through before it settles; anything else is terminal. */
export const IN_FLIGHT_STATUSES = ["PENDING", "PROCESSING", "RETRIEVING"];
export const carequalitySettingsService = {
    getFacility: () => settings.get("carequality-facility/"),
    saveFacility: (facility) => settings.put("carequality-facility/", facility),
};
export const carequalityService = {
    getNetworkQuery: (patientId, orderId) => patients.get(`${patientId}/network-query/`, { params: orderId == null ? {} : { order_id: orderId } }),
    runInsights: (patientId, orderId) => patients.post(`${patientId}/network-query/insights/`, { orderId }),
    triggerNetworkQuery: (patientId, orderId) => patients.post(`${patientId}/network-query/`, { orderId }),
    getDocumentLink: (patientId, documentId) => patients.get(`${patientId}/network-query/documents/${documentId}/link/`),
    getSelection: (orderId) => intake.get(`orders/${orderId}/network-documents/`),
    saveSelection: (orderId, documentIds) => intake.put(`orders/${orderId}/network-documents/`, { documentIds }),
};
